export default "__VITE_ASSET__fd3441fc__"